@if (error$ | async) {
  <hyperkit-message class="error" type="error"></hyperkit-message>
} @else {
  @if (stagedHuntPackages$ | async; as stagedHuntPackages) {
    <div>
      @if (deployedHuntPackages$ | async; as deployedHuntPackages) {
        <div>
          @if (outdatedHuntPackages$ | async; as outdatedHuntPackages) {
            <div>
              @if (
                stagedHuntPackages &&
                deployedHuntPackages &&
                outdatedHuntPackages
              ) {
                <cyborg-section id="deployment-queue" class="charts">
                  <div class="row">
                    <div class="stats-container">
                      <div class="stat-card">
                        <div class="stat-label">
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >Staged</hyperkit-typography
                          >
                        </div>
                        <div class="stat-number">
                          <hyperkit-typography
                            variant="h1"
                            align="left"
                            color="primary"
                            >{{
                              stagedHuntPackages.meta.totalItems
                            }}</hyperkit-typography
                          >
                        </div>
                      </div>
                      <div class="stat-card">
                        <div class="stat-label">
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >Deployed</hyperkit-typography
                          >
                        </div>
                        <div class="stat-number">
                          <hyperkit-typography
                            variant="h1"
                            align="left"
                            color="primary"
                            >{{
                              deployedHuntPackages.meta.totalItems
                            }}</hyperkit-typography
                          >
                        </div>
                      </div>
                      <div class="stat-card">
                        <div class="stat-label">
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >Outdated</hyperkit-typography
                          >
                        </div>
                        <div class="stat-number">
                          <hyperkit-typography
                            variant="h1"
                            align="left"
                            color="primary"
                            >{{
                              outdatedHuntPackages.meta.totalItems
                            }}</hyperkit-typography
                          >
                        </div>
                      </div>
                      <div class="stat-card">
                        <div class="stat-label">
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >Bookmarked</hyperkit-typography
                          >
                        </div>
                        <div class="stat-number">
                          <hyperkit-typography
                            variant="h1"
                            align="left"
                            color="primary"
                            >{{ bookmarkedHuntPackages }}</hyperkit-typography
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <cyborg-section-title>
                    <div class="logo">
                      <hyperkit-typography
                        variant="h3"
                        align="left"
                        color="primary"
                        >Hunt Package Deployment Queue</hyperkit-typography
                      >
                    </div>
                  </cyborg-section-title>
                  <hyperkit-tab-bar variant="secondary" mode="underline">
                    <hyperkit-tab
                      text="Staged Hunt Packages"
                      [count]="stagedHuntPackages.items.length"
                      [selected]="true"
                    >
                      @for (dep of stagedHuntPackages.items; track dep) {
                        <deployment-queue
                          [deployItem]="dep"
                          (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                        ></deployment-queue>
                      }
                      <kendo-datapager
                        [style.width.%]="100"
                        [pageSize]="pageSize"
                        [skip]="stagedSkip"
                        [total]="stagedHuntPackages.meta.totalItems"
                        [pageSizeValues]="false"
                        (pageChange)="onStagedPageChange($event)"
                      >
                      </kendo-datapager>
                    </hyperkit-tab>
                    <hyperkit-tab
                      text="Deployed Hunt Packages"
                      [count]="deployedHuntPackages.items.length"
                    >
                      @for (dep of deployedHuntPackages.items; track dep) {
                        <deployment-queue
                          [deployItem]="dep"
                          (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                        ></deployment-queue>
                      }
                      <kendo-datapager
                        [style.width.%]="100"
                        [pageSize]="pageSize"
                        [skip]="deployedSkip"
                        [total]="deployedHuntPackages.meta.totalItems"
                        [pageSizeValues]="false"
                        (pageChange)="onDeployedPageChange($event)"
                      >
                      </kendo-datapager>
                    </hyperkit-tab>
                    <hyperkit-tab
                      text="Outdated Hunt Packages"
                      [count]="outdatedHuntPackages.items.length"
                    >
                      @for (dep of outdatedHuntPackages.items; track dep) {
                        <deployment-queue
                          [deployItem]="dep"
                          (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                        ></deployment-queue>
                      }
                      <kendo-datapager
                        [style.width.%]="100"
                        [pageSize]="pageSize"
                        [skip]="outdatedSkip"
                        [total]="outdatedHuntPackages.meta.totalItems"
                        [pageSizeValues]="false"
                        (pageChange)="onOutdatedPageChange($event)"
                      >
                      </kendo-datapager>
                    </hyperkit-tab>
                  </hyperkit-tab-bar>
                  <!-- <kendo-tabstrip>
                                    <kendo-tabstrip-tab title="Staged Hunt Packages" [selected]="first">
                                      <ng-template kendoTabContent>
                                        <deployment-queue
                                          *ngFor="let dep of stagedHuntPackages.items"
                                          [deployItem]="dep"
                                          (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                                        ></deployment-queue>
                                        <kendo-datapager
                                          [style.width.%]="100"
                                          [pageSize]="pageSize"
                                          [skip]="stagedSkip"
                                          [total]="stagedHuntPackages.meta.totalItems"
                                          [pageSizeValues]="false"
                                          (pageChange)="onStagedPageChange($event)"
                                          >
                                        </kendo-datapager>
                                      </ng-template>
                                    </kendo-tabstrip-tab>
                                    <kendo-tabstrip-tab
                                      title="Deployed Hunt Packages"
                                      [selected]="second"
                                      >
                                      <ng-template kendoTabContent>
                                        <deployment-queue
                                          *ngFor="let dep of deployedHuntPackages.items"
                                          [deployItem]="dep"
                                          (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                                        ></deployment-queue>
                                        <kendo-datapager
                                          [style.width.%]="100"
                                          [pageSize]="pageSize"
                                          [skip]="deployedSkip"
                                          [total]="deployedHuntPackages.meta.totalItems"
                                          [pageSizeValues]="false"
                                          (pageChange)="onDeployedPageChange($event)"
                                          >
                                        </kendo-datapager>
                                      </ng-template>
                                    </kendo-tabstrip-tab>
                                    <kendo-tabstrip-tab [selected]="third">
                                      <ng-template kendoTabTitle>
                                        <span class="outdated-tab-title">
                                          Outdated Hunt Packages
                                          <hyperkit-badge
                                            variant="warning"
                                            [text]="
                                              outdatedHuntPackages.items.length.toString()
                                            "
                                          ></hyperkit-badge>
                                        </span>
                                        </ng-template>
                                        <ng-template kendoTabContent>
                                          <deployment-queue
                                            *ngFor="let dep of outdatedHuntPackages.items"
                                            [deployItem]="dep"
                                            (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                                          ></deployment-queue>
                                          <kendo-datapager
                                            [style.width.%]="100"
                                            [pageSize]="pageSize"
                                            [skip]="outdatedSkip"
                                            [total]="outdatedHuntPackages.meta.totalItems"
                                            [pageSizeValues]="false"
                                            (pageChange)="onOutdatedPageChange($event)"
                                            >
                                          </kendo-datapager>
                                        </ng-template>
                                      </kendo-tabstrip-tab>
                                    </kendo-tabstrip> -->
                </cyborg-section>
              } @else {
                <div class="loading">
                  <kendo-loader
                    type="pulsing"
                    themeColor="primary"
                    size="large"
                  >
                  </kendo-loader>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}
<cyborg-modal-deploy id="deploy" class="modal"></cyborg-modal-deploy>
